import React from 'react'
import "./HeroSection.css";

function HeroSection({ CuserName, CuserPhone, CuserLoanAmount, monthlyEMI, onContinue = () => { } }) {
  return (
    <div className='w-full flex flex-col max-w-[400px] justify-center items-center px-4 plv16-hero'>
      <div
        className='w-[186px] h-[30px] rounded-[50px] p-[1px] mb-3'
        style={{
          backgroundImage:
            "linear-gradient(104.79deg, rgba(77, 97, 102, 0.8) 15.49%, #CADDE1 44.57%, rgba(76, 91, 95, 0.6) 73.66%)",
        }}
      >
        <div
          className='w-full h-full rounded-[49px] flex items-center'
          style={{
            backgroundColor: "#CADDE1",
            backdropFilter: "blur(6px)",
            WebkitBackdropFilter: "blur(6px)",
            gap: "5px",
            paddingLeft: "5px",
          }}
        >
          <div className='w-[18px] h-[18px] bg-[#1F2937] rounded-full flex items-center justify-center flex-shrink-0'>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 2.75L14.96 8.44L21.25 9.32L16.7 13.52L17.8 19.75L12 16.83L6.2 19.75L7.3 13.52L2.75 9.32L9.04 8.44L12 2.75Z"
                fill="#FBBF24"
              />
            </svg>
          </div>
          <span className='text-[11px] text-gray-600 font-medium whitespace-nowrap'>
            Trusted by <b>1M+ Customers</b>
          </span>
        </div>
      </div>

      <div className='w-[86px] h-[86px] rounded-full flex items-center justify-center mb-[15px]'>

            <svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M43 86C66.7482 86 86 66.7483 86 43C86 19.2518 66.7482 0 43 0C19.2518 0 0 19.2518 0 43C0 66.7483 19.2518 86 43 86Z" fill="#A8DAC0" fill-opacity="0.1" />
              <path d="M42.9999 76.561C61.5352 76.561 76.5609 61.5352 76.5609 43C76.5609 24.4648 61.5352 9.43903 42.9999 9.43903C24.4647 9.43903 9.43896 24.4648 9.43896 43C9.43896 61.5352 24.4647 76.561 42.9999 76.561Z" fill="#A8DAC0" fill-opacity="0.3" />
              <path d="M42.8805 67.1389C56.2378 67.1389 67.0661 56.3107 67.0661 42.9534C67.0661 29.596 56.2378 18.7678 42.8805 18.7678C29.5232 18.7678 18.6949 29.596 18.6949 42.9534C18.6949 56.3107 29.5232 67.1389 42.8805 67.1389Z" fill="#A8DAC0" />
              <path d="M40.5097 50.2365C40.0355 50.2365 39.5614 50.0553 39.1991 49.693L32.6645 43.1585C31.9399 42.4339 31.9399 41.2618 32.6645 40.5399C33.3891 39.8179 34.5612 39.8179 35.2831 40.5399L40.5071 45.7638L50.2063 36.0645C50.9309 35.3399 52.103 35.3399 52.8249 36.0645C53.5495 36.7891 53.5495 37.9612 52.8249 38.6831L41.815 49.693C41.4527 50.0553 40.9786 50.2365 40.5044 50.2365H40.5097Z" fill="white" />
            </svg>

      </div>

      <h2
        className='text-[22px] leading-[24px] font-semibold text-center mb-[10px] text-black'
        style={{
          fontFamily:
            "Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
        }}
      >
        {CuserName ? `Hello, ${CuserName}!` : "Hello! Sir/Madam"}
      </h2>

      <p
        className='text-[13px] tracking-[-0.02em] text-center mb-4'
        style={{
          fontFamily:
            "Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
          color: "#7F8497",
        }}
      >
        You are pre-approved for this Personal Loan
      </p>

      {/* <div
        className='w-full rounded-2xl p-[1px] plv16-preapproved-border'
        style={{
          backgroundImage:
            "linear-gradient(104.79deg, rgba(77, 97, 102, 0.8) 15.49%, #CADDE1 44.57%, rgba(76, 91, 95, 0.2) 73.66%)",
        }}
      >
        <div className='rounded-[15px] p-4 bg-white plv16-preapproved-card' style={{
          border: "1px solid",
          borderImageSource: "linear-gradient(104.79deg, rgba(77, 97, 102, 0.8) 15.49%, #CADDE1 44.57%, rgba(76, 91, 95, 0.2) 73.66%)",
        }}>
          <div className='flex items-start justify-center plv16-preapproved-cols'>
            <div className='w-[155px] mr-4 flex-shrink-0 plv16-preapproved-left'>
              <span
                className='text-[13px] leading-[14px] mb-[10px] text-black font-normal'
                style={{
                  fontFamily:
                    "Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
                }}
              >
                Your pre-approved loan amount
              </span>
              <div
                className='text-[30px] font-bold mb-0 text-black'
                style={{
                  fontFamily:
                    "Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
                }}
              >
                ₹{Number(userLoanAmount).toLocaleString("en-IN")}
              </div>
            </div>
            <div className='w-px h-[73px] bg-gray-200 self-stretch my-auto plv16-preapproved-divider' style={{
              border: "1px solid",
              borderImageSource: "linear-gradient(90deg, rgba(68, 86, 90, 0) 0%, #C8DBDF 50%, rgba(68, 86, 90, 0) 100%)",
            }}>
            </div>
            <div className='w-[100px] ml-4 flex-shrink-0 plv16-preapproved-right'>
              <span
                className='text-[13px] leading-[14px] mb-[10px] text-black font-normal'
                style={{
                  fontFamily:
                    "Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
                }}
              >
                Your monthly EMI is
              </span>
              <div
                className='text-[22px] font-bold mb-0 text-black'
                style={{
                  fontFamily:
                    "Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
                }}
              >
                ₹{monthlyEMI}
              </div>
            </div>
          </div>

          <div
            className='w-100 h-[60px] rounded-[15px] p-[1px] mt-[30px] mx-auto plv16-hero-cta-border'
            style={{
              backgroundImage:
                "linear-gradient(267.34deg, #00A953 1.33%, #009F4E 46.82%, #75FFB9 92.32%)",
            }}
          >
            <button
              onClick={onContinue}
              className='w-full h-full rounded-[14px] bg-gradient-to-b from-[#12F280] to-[#0DB069] flex items-center justify-center text-black text-[16px] leading-[16px] font-medium text-center'
              style={{
                fontFamily:
                  "Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
              }}
            >
              Continue to Unlock My Loan
            </button>
          </div>

          <div className='flex items-center justify-center gap-6 mt-3 plv16-hero-benefits'>
            <div className='flex items-center gap-2'>
              <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.72222 0.500031L0.5 8.90003H7L6.27778 14.5L13.5 6.10003H7L7.72222 0.500031Z" fill="white" stroke="#2A3A3F" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

              <span
                className='text-[13px] leading-[18px] text-center text-black font-normal'
                style={{
                  fontFamily:
                    "Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
                }}
              >
                Takes ~5 minutes
              </span>
            </div>
            <div className='flex items-center gap-2'>
              <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 0.5H7.38867C7.53692 0.5 7.67747 0.565897 7.77246 0.679688L11.6064 5.28027C11.6812 5.3701 11.7227 5.4837 11.7227 5.60059V14.7139C11.7227 14.9899 11.4986 15.2136 11.2227 15.2139H1C0.723858 15.2139 0.5 14.99 0.5 14.7139V1C0.5 0.723858 0.723857 0.5 1 0.5Z" fill="white" stroke="#2A3A3F" stroke-linecap="round" />
                <path d="M7.85718 0.873016V4.2381C7.85718 4.79038 8.30489 5.2381 8.85718 5.2381H11.3492" stroke="#2A3A3F" stroke-linecap="round" />
                <path d="M9 8.00003L3 8M5.57143 10L3 10" stroke="#2A3A3F" stroke-linecap="round" />
              </svg>

              <span
                className='text-[13px] leading-[18px] text-center text-black font-normal'
                style={{
                  fontFamily:
                    "Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
                }}
              >
                Zero paperwork
              </span>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  )
}

export default HeroSection
